var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvax = function SvgAvax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avax_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E84142",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.838 31.282h-4.163c-.875 0-1.307 0-1.57-.169a1.06 1.06 0 0 1-.48-.828c-.016-.31.2-.691.633-1.45l10.274-18.14c.438-.77.66-1.156.938-1.299a1.06 1.06 0 0 1 .96 0c.279.143.5.528.938 1.298l2.112 3.693.01.02c.472.825.712 1.245.816 1.686.117.481.117.984 0 1.465-.105.444-.342.866-.82 1.705l-5.4 9.556-.013.024c-.476.833-.715 1.255-1.05 1.574-.362.345-.8.6-1.28.743-.438.122-.926.122-1.905.122m10.51 0h5.961c.88 0 1.323 0 1.587-.173a1.06 1.06 0 0 0 .478-.835c.016-.3-.195-.665-.609-1.382l-.044-.074-2.986-5.118-.034-.057c-.42-.711-.633-1.07-.904-1.209a1.05 1.05 0 0 0-.953 0c-.275.143-.495.518-.932 1.272l-2.977 5.118-.01.017c-.435.754-.654 1.13-.637 1.439a1.07 1.07 0 0 0 .478.833c.259.17.701.17 1.581.17Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avax_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgAvax;